import './App.css';
import { BaseLayout } from './Containers/BaseLayout';

function App() {
  return (
    <div className="App">
      <BaseLayout>
        Hello
      </BaseLayout>
    </div>
  );
}

export default App;
